import { currentSession, type UiConfig } from './auth.js';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly issues?: { path: string; message: string }[],
  ) {
    super(message);
  }
}

let config: UiConfig;
export function setConfig(c: UiConfig): void {
  config = c;
}

/** Calls the admin API ("/settings" → "<api base>/settings") with the signed-in user's token. */
export async function api<T = unknown>(method: string, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = { accept: 'application/json' };
  if (body !== undefined) headers['content-type'] = 'application/json';
  if (config.auth === 'sso') {
    const s = currentSession();
    if (!s) throw new ApiError(401, 'Your session expired. Please sign in again.');
    headers.authorization = `Bearer ${s.idToken}`;
  }
  const res = await fetch(`${config.api}${path}`, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
  const text = await res.text();
  let data: unknown = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const d = (data ?? {}) as { error?: string; message?: string; issues?: { path: string; message: string }[] };
    throw new ApiError(res.status, d.error ?? d.message ?? `Request failed (${res.status})`, d.issues);
  }
  return data as T;
}

export const get = <T>(path: string) => api<T>('GET', path);
